import React from 'react';
import { Box, Typography, List, ListItem, ListItemButton, Divider } from '@mui/material';
import { useKBTheme } from '../hooks/useKBTheme';
import { useNavigate } from 'react-router-dom';
import { SearchResult } from '../hooks/useSearch';

interface SearchResultsProps {
  results: SearchResult[];
  query: string;
}

export const SearchResults: React.FC<SearchResultsProps> = ({ results, query }) => {
  const { mode } = useKBTheme();
  const navigate = useNavigate();

  if (results.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography
          variant="h6"
          sx={{
            color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#64748b',
            mb: 1,
          }}
        >
          No results found
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : '#94a3b8',
          }}
        >
          Try different keywords or browse categories
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          mb: 3,
          color: mode === 'dark' ? '#fff' : '#0f172a',
        }}
      >
        Found {results.length} {results.length === 1 ? 'result' : 'results'} for "{query}"
      </Typography>
      <List sx={{ p: 0 }}>
        {results.map((result, index) => (
          <React.Fragment key={result.articleId}>
            <ListItem disablePadding sx={{ mb: 2 }}>
              <ListItemButton
                onClick={() => navigate(`/knowledge-base/article/${result.articleId}`)}
                sx={{
                  p: 3,
                  borderRadius: 3,
                  background: mode === 'dark'
                    ? 'rgba(15, 23, 42, 0.6)'
                    : 'rgba(255, 255, 255, 0.8)',
                  border: mode === 'dark'
                    ? '1px solid rgba(71, 85, 105, 0.4)'
                    : '1px solid rgba(226, 232, 240, 0.8)',
                  '&:hover': {
                    background: mode === 'dark'
                      ? 'rgba(99, 102, 241, 0.15)'
                      : 'rgba(99, 102, 241, 0.08)',
                    borderColor: mode === 'dark'
                      ? 'rgba(99, 102, 241, 0.5)'
                      : 'rgba(99, 102, 241, 0.4)',
                  },
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    mb: 1,
                    color: mode === 'dark' ? '#fff' : '#0f172a',
                  }}
                >
                  {result.title}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: '#6366f1',
                    mb: 1,
                    fontSize: '0.75rem',
                    fontWeight: 600,
                  }}
                >
                  {result.category}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#64748b',
                    lineHeight: 1.7,
                  }}
                >
                  {result.excerpt}
                </Typography>
              </ListItemButton>
            </ListItem>
            {index < results.length - 1 && <Divider sx={{ my: 2 }} />}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};








